/*
 * @Auth: linjituan
 * @Date: 2021-11-05 21:16:41
 * @LastEditors: linjituan
 * @LastEditTime: 2021-12-20 15:22:16
 */
// 配置可选择icon
const iconList = [{ icon: 'icon-feiyongshenqing' }, { icon: 'icon-ywzjicon-gas' }, { icon: 'icon-hetongshenqing' }]
export default iconList
